module.exports = __webpack_public_path__ + "img/w9-b2.92c1269a.jpg";